import React, { useState, useEffect } from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { toast } from "react-toastify";
import api from "../../../api/api";
import { useForm } from "react-hook-form";

const TransactionCreate = () => {
  const { register, handleSubmit, unregister, setValue, reset } = useForm();

  const [services, setServices] = useState([]);
  const [contentType, setContentType] = useState(null);
  const [serviceObjects, setServiceObjects] = useState([]);
  const [companyList, setCompanyList] = useState({})



  useEffect(() => {
    if (contentType !== null) {
      api
        .get(`/services/?content_type=${contentType}`)
        .then((response) => {
          // console.log("response", response.data[0].service_objects)
          setServiceObjects(response.data[0].service_objects);
        })
        .catch((error) => {
          console.log("error", error);
        });
    }
  }, [contentType]);

  // console.log("contentType", contentType)

  useEffect(() => {
    api
      .get("/services/")
      .then((response) => {
        // console.log("services", response.data)
        setServices(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const handleSub = (data) => {

    api.post("/transactions/", data)
    .then(response=> {
      toast.success("Transaction Created Successfully")
      reset(data)

    }).catch(error=> {
      toast.error("Failed to create")
    })
  }



 const showCompany = (ids) => {

   let arr =   serviceObjects.filter((item=> {
      console.log("item", item.id, "ids", ids)
       return  parseInt(item.id) === parseInt(ids)
     }))
  
     setCompanyList(arr[0]) 
 } 

 
  return (
    <div>
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Transaction Create
      </h1>
      <div className="">
        {/* <img
          src={}
          alt=""
          className="mx-auto mt-4"
        /> */}
      </div>

      <form onSubmit={handleSubmit(handleSub)}>
        
        <div className="grid md:grid-cols-2  grid-cols-1 border-2 border-primary-blue font-bold mt-3">
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Transaction Type</label>
            <select
              className="text-primary-blue"
              {...register("transaction_type", { required: false })}
            >
              <option>Select</option>
              <option value="credit">Credit</option>
              <option value="debit">Debit</option>
            </select>
          </div>
          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Status</label>
            <select
              className="text-primary-blue"
              {...register("status", { required: false })}
            >
              <option>Select</option>
              <option value="processing">Processing</option>
              <option value="approved">Approved</option>
              <option value="rejected">Rejected</option>
            </select>
          </div>

          <div className="flex   p-3 border-b  border-primary-blue items-center gap-3 text-red-600">
            <label>Amount</label>
            <br />
            <input
              className="text-primary-blue"
              type="number"
              placeholder="Amount"
              {...register("amount", { required: false })}
            />
          </div>

          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Services</label>
            <select
              className="text-primary-blue"
              {...register("service_object_content_type", {
                required: false,
                onChange: (e) => {
                  setContentType(e.target.value);
                },
              })}
            >
              <option>Select</option>
              {services.map((service, i) => {
                return (
                  <option key={i} value={service.content_type}>
                    {service.name}
                  </option>
                );
              })}
            </select>
          </div>

          <div className="flex   p-3 border-b border-r border-primary-blue items-center gap-3 text-red-600">
            <label>Company Name</label>
            <select
              className="text-primary-blue"
              {...register("service_object_id", {
                required: false,
                onChange : (e) => {
                  showCompany(e.target.value)
                }
              })}
            >
              <option>Select</option>
              {serviceObjects.map((obj, i) => {
                return (
                  <option key={i} value={obj.id}>
                    {obj.company__company_name}
                  </option>
                );
              })}
            </select>
          </div>
        </div>

        <table className="border-primary-blue min-w-full border text-center mt-4">
          <thead className="font-Bree bg-primary-red text-lg font-bold">
            <tr className="">
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                SN.
              </th>
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                User
              </th>
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                Company Name
              </th>
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                Service Charge
              </th>
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                Discount
              </th>

              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
               Created At
              </th>
              <th
                scope="col"
                className="border-primary-blue border-2 px-6 py-4 text-sm font-medium text-white"
              >
                Completed At
              </th>
            </tr>
          </thead>
          <tbody className="font-Acme">
           
             <tr className="border-primary-blue border-2 bg-white">
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
              1
            </td>
            <td>{companyList.user ?? "null"}</td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
            {companyList.company__company_name}
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
            {companyList.service_charge}
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
            {companyList.discount}
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
            {companyList.created_at}
            </td>
            <td className="border-primary-blue whitespace-nowrap border-2 px-6 py-4 text-sm font-light text-gray-900">
            {companyList.completed_at ?? "null"}
            </td>
             </tr>

          </tbody>
        </table>

        <button type="submit" className=" bg-primary-blue text-white text-base p-2 rounded-2xl mt-3">
      Submit
    </button>

      </form>
    </div>
  );
};

export default TransactionCreate;
